/** แปลง path รูปภาพ (จาก /api/Upload/image เช่น "/uploads/xxx.png") เป็น URL ที่โหลดได้จริง — รองรับทั้ง path ที่อัปโหลดจริง, asset ของ FE, และ blob:/data:/http(s) ที่ใช้พรีวิวก่อนอัปโหลดเสร็จ
 *  uploadsBaseURL มีได้ 2 รูปแบบแล้วแต่ environment: ลงท้ายด้วย "/uploads" อยู่แล้ว (prod เช่น "https://app.surveybox.cloud/uploads")
 *  หรือไม่ลงท้ายด้วย "/uploads" (dev เช่น "/core" ที่ต้องพึ่ง proxy คง "/uploads/..." ไว้ในพาธ) — ต้องเช็กก่อนตัด "uploads/" ออกจาก path
 *  ไม่งั้นจะได้ URL ผิดไปคนละแบบในแต่ละ environment (พาธหาย "/uploads/" ใน dev, หรือซ้ำ "/uploads/uploads/" ใน prod) */
export function resolveMediaUrl(uploadsBaseURL: string, path?: string | null): string | null {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:') || path.startsWith('blob:')) return path;
  if (path.startsWith('assets/')) return path;
  const base = uploadsBaseURL.replace(/\/$/, '');
  const cleanPath = path.replace(/^\/+/, '');
  const baseEndsWithUploads = /\/uploads$/i.test(base);
  const normalizedPath = baseEndsWithUploads && cleanPath.startsWith('uploads/') ? cleanPath.slice('uploads/'.length) : cleanPath;
  return `${base}/${normalizedPath}`;
}
